import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { fetchMatchs, fetchClassement, fetchDernierResultat } from "../api/fff";
import dayjs from "dayjs"; // pour gérer les dates
import Countdown from "../components/Match/Countdown";
import GallerySlider from '../components/Layout/GallerySlider';
import CtaBoutique from "../components/Layout/CtaBoutique";
import SponsorsSection from "../components/Layout/SponsorsSection";
import HeroSection from "../components/Layout/HeroSection";
import Navbar from "../components/Layout/Navbar";
import TopBar from "../components/Layout/TopBar";
import ClassementEtMatchsSection from "../components/Layout/ClassementEtMatchsSection";
import StatsN2Section from "../components/Layout/StatsN2Section";
import ProchainMatchBar from "../components/Layout/ProchainMatchBar";
import GalleryHomeSection from '../components/Layout/GalleryHomeSection';
import useScrollReveal from '../utils/useScrollReveal';
import PartenairesSection from '../components/Layout/PartenairesSection';
import CtaFanZone from "../components/Layout/CtaFanZone";
import StatsEquipeN2Section from '../components/Layout/StatsEquipeN2Section';
import ActualitesSection from '../components/Layout/ActualitesSection';
import PlayerOfTheMonth from "../components/Home/PlayerOfTheMonth";
import FanZoneTeaser from "../components/Home/FanZoneTeaser";
import SocialWall from "../components/Home/SocialWall";


export default function HomePage() {
  const [classement, setClassement] = useState([]);
  const [dernierMatch, setDernierMatch] = useState(null);
  const [prochainMatch, setProchainMatch] = useState(null);
  const [loadingMatches, setLoadingMatches] = useState(true);

  // 🔥 CTA - Rejoins-nous vite
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const ctaRef = useScrollReveal();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchClassement = async () => {
      try {
        // Compétition N2 (cp_no=439451), Phase 1, Poule 2 (POULE B)
        const res = await axios.get("/api/compets/439451/phases/1/poules/2/classement_journees");
        if (res.data && Array.isArray(res.data)) {
          setClassement(res.data);
        } else if (res.data && res.data["hydra:member"]) {
          setClassement(res.data["hydra:member"]);
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error("Erreur chargement classement :", err);
        }
      }
    };

    fetchClassement();
  }, []);

  useEffect(() => {
    const loadMatches = async () => {
      try {
        setLoadingMatches(true);

        // Charger les matchs (passés et à venir)
        const { past, upcoming } = await fetchMatchs();

        // Charger le dernier résultat
        const lastResult = await fetchDernierResultat();

        // Si l'API retourne des données, on les utilise
        if (lastResult) {
          setDernierMatch(lastResult);
        } else if (past && past.length > 0) {
          // Fallback : utiliser le dernier match de la liste "past"
          setDernierMatch(past[0]);
        }

        // Si l'API retourne un prochain match, on l'utilise
        if (upcoming && upcoming.length > 0) {
          setProchainMatch(upcoming[0]);
        }

        if (process.env.NODE_ENV === 'development') {
          console.log('✅ Données API FFF chargées:', {
            dernierMatch: !!lastResult || (past && past.length > 0),
            prochainMatch: !!(upcoming && upcoming.length > 0),
            nombreMatchsPasses: past?.length || 0,
            nombreMatchsAvenir: upcoming?.length || 0
          });
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Erreur chargement matchs:', error);
        }
      } finally {
        setLoadingMatches(false);
      }
    };

    loadMatches();
  }, []);

  // 🟡 ➕ Nouvelle useEffect pour forcer le rendu Facebook
  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="homepage">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
          <div className="absolute left-0 right-0 z-10" >
            <ProchainMatchBar match={prochainMatch} />
          </div>
        </div>
      </div>

      <HeroSection />

      <ClassementEtMatchsSection
        classement={classement}
        dernierMatch={dernierMatch}
        prochainMatch={prochainMatch}
        loading={loadingMatches}
      />

      {/* NOUVEAU: Teaser FanZone */}
      <FanZoneTeaser match={prochainMatch} />

      {/* NOUVEAU: Joueur du mois */}
      <PlayerOfTheMonth />

      {/* Section Stats N2 */}
      <StatsN2Section />

      {/* NOUVEAU: Social Wall */}
      <SocialWall />

      {/* Statistiques équipe N2 */}
      <StatsEquipeN2Section />

      <div id="actualites">
        <ActualitesSection />
      </div>

      <GalleryHomeSection />

      <CtaBoutique />

      {/* REFONTE: Partenaires */}
      <PartenairesSection />

    </div>
  );
}
